import { Enums } from '@libs/mtjr/shared/generated/types';
import { Expose } from 'class-transformer';

export class VariationAttributeDtoMap {
  @Expose()
  id!: string;

  @Expose()
  typeLabel!: string;

  @Expose()
  typeKey!: string;

  @Expose()
  type!: Enums.AttributeType;

  @Expose()
  label!: string;

  @Expose()
  key!: string;
}
